import ResizeWrapper from '@/components/ResizeWrapper';
import utils from '@/utils/utils';
import MainArea from './MainArea';
import styles from './index.module.less';
import SideBarMenu from '@/components/SideBarMenu';
import { SideBarProvider } from '@/context/SideBarContext';
import { useBackground } from '@/context/BackgroundContext';

function MainPageContent() {
  const { backgroundImage } = useBackground();

  return (
    <ResizeWrapper className={styles.container}>
      <div
        className={styles.main}
        style={{
          padding: utils.isMobile() ? '' : '24px 124px',
        }}
      >
        <div className={`${styles.mainArea} ${utils.isMobile() ? styles.isMobile : ''}`}>
          <MainArea />
        </div>
        {backgroundImage && <div className={styles.chatBackgroundImg}>{backgroundImage && <img src={backgroundImage} />}</div>}
      </div>
      <SideBarMenu />
    </ResizeWrapper>
  );
}

export default function MainPage() {
  return (
    <SideBarProvider>
      <MainPageContent />
    </SideBarProvider>
  );
}
